import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { PipesModule } from '@shared/pipes/pipes.module';
import { OpportunityListViewComponent } from './opportunity-list-view/opportunity-list-view.component';
import { SparkCoreModule } from '@core/core.module';



@NgModule({
  declarations: [
    OpportunityListViewComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    PipesModule,
    SparkCoreModule
  ],
  exports: [
    OpportunityListViewComponent
  ]
})
export class OpportunityViewModule { }
